<template>
  <div class="list-container">
    <div class="list-section">
      <div class="bread-crumbs">
        <router-link to="/">首页</router-link>
        <template v-if="breadcrumbList.length">
          <router-link v-for="nav in breadcrumbList" :key="`nav-${nav.id}`" :to="`/category/${nav.id}`">{{ nav.name
          }}</router-link>
        </template>
      </div>
      <!-- 列表头部 -->
      <div class="list-header">
        <div class="list-title">{{ categoryRes.name ? categoryRes.name : '列表' }}({{ total }})</div>
        <div class="list-header-extra">
          <div :class="['list-filter-mini', isCollapse ? '' : 'active']" @click="toggleMiniFilter">筛选</div>
          <div class="list-limit">
            <label htmlFor="limit-items">查看:&nbsp;</label>
            <el-select class="limit-items" v-model="limit" placeholder="每页大小" @change="optsChange('limit')">
              <el-option :value="24" label="24"></el-option>
              <el-option :value="48" label="48"></el-option>
              <el-option :value="96" label="96"></el-option>
            </el-select>
          </div>
          <div class="list-sort">
            <el-select class="sort-items" v-model="sort" placeholder="排序方式" @change="optsChange('sort')">
              <el-option value="new" label="最新发售"></el-option>
              <el-option value="sales" label="销量"></el-option>
              <el-option value="price:desc" label="价格↓"></el-option>
              <el-option value="price:asc" label="价格↑"></el-option>
            </el-select>
          </div>
        </div>
        <div class="list-filter-opts" v-if="!isCollapse">
          <ListFilter scope="category" mode="mini" :filterOpts="filterOpts" />
          <div class="list-filter-opts-close" @click="toggleMiniFilter($event, true)">关闭</div>
        </div>
      </div>
      <div class="list-wrapper">
        <div class="filter-items">
          <ListFilter scope="category" :filterOpts="filterOpts"
            :title="`${breadcrumbList.length ? breadcrumbList[0].name : ''}`" />
        </div>
        <div class="list-items">
          <!-- 专题Banner -->
          <div class="topic-banner" v-if="pics && (pics.big || pics.small)">
            <picture class="homepage-content-main-image">
              <source v-if="pics.small" media="(max-width:640px)" :srcset="pics.small" />
              <img media="(min-width:768px)" :src="pics.big" />
            </picture>
          </div>

          <!-- 已选过滤条件 -->
          <div class="list-filter-opts-selected" v-if="showSelectedFilterItem">
            <div class="list-filter-flag">筛选</div>
            <!-- 已选过滤条件：性别 -->
            <template v-if="getCheckedList('genders').length">
              <div class="filter-item">
                <span class="filter-item-name">性别: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('genders')" :key="i">
                  {{ item | findFilterItem(filterOpts['genders']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('genders', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：尺寸 -->
            <template v-if="getCheckedList('sizes').length">
              <div class="filter-item">
                <span class="filter-item-name">尺码: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('sizes')" :key="i">
                  {{ item | findFilterItem(filterOpts['sizes']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('sizes', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：颜色 -->
            <template v-if="getCheckedList('colors').length">
              <div class="filter-item">
                <span class="filter-item-name">颜色: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('colors')" :key="i">
                  {{ item }}
                  <a class="filter-item-remove" @click="removeFilterItem('colors', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：价格 -->
            <template v-if="getCheckedList('prices').length">
              <div class="filter-item">
                <span class="filter-item-name">价格: </span>
                <span class="filter-item-value">
                  <span class="rmb-symbol">{{ filterOpts.prices.checked }}</span>
                  <a class="filter-item-remove" @click="removeFilterItem('prices', filterOpts.prices.checked)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <div class="clear-all" @click="clearAll">清除</div>
          </div>
          <!-- 列表主体 -->
          <div class="list-context">
            <ul class="list-result">
              <li v-for="(item, index) in list" :key="index">
                <ListItem :data="item" @itemview="showItemDialog" />
              </li>
            </ul>
            <div class="paging">
              <Pagination :total="total" :limit="limit" :current="currPage" @change="changePage" />
              <div class="list-footer-size">
                <label htmlFor="footer-limit-size" class="list-footer-size-hits">查看:&nbsp;</label>
                <el-select class="list-footer-size-items" v-model="limit" placeholder="每页大小"
                  @change="optsChange('limit')">
                  <el-option :value="24" label="24"></el-option>
                  <el-option :value="48" label="48"></el-option>
                  <el-option :value="96" label="96"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 快速购买 - 商品弹窗 -->
    <div class="dialog view-item-dialog" v-if="viewItem && viewItem.id && viewItem.color">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <div class="dialog-title">商品信息</div>
          <button type="button" class="dialog-close" @click="hideItemDialog">
            <span class="close-icon"></span>
          </button>
        </div>
        <div class="dialog-body">
          <ViewItemInfo scope="list" :id="viewItem.id" :color="viewItem.color" confirmText="立即下单" @notify="setNotify"
            @confirm="toCheckout" />
        </div>
      </div>
    </div>
    <!-- 快速购买 - 通知弹窗 -->
    <div class="dialog notify-dialog" v-if="notifyItem">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <div class="dialog-title">到货通知</div>
          <button class="dialog-close" @click="hideNotifyDialog">
            <span class="close-icon"></span>
          </button>
        </div>
        <div class="dialog-body">
          <ItemNotify :source="notifyItem" @comfirm="sendNotify" />
        </div>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <div class="dialog login-dialog" v-if="showLogin">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="hideLoginDialog">&#xe612;</i>
        </div>
        <div class="dialog-body">
          <Login :returnUrl="returnUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import types from '@/store/types';
import api from '@/utils/api';
import ListFilter from '@/components/ListFilter.vue';
import ListItem from '@/components/ListItem.vue';
import Pagination from '@/components/Pagination.vue';
import ViewItemInfo from '@/components/ViewItemInfo.vue';
import ItemNotify from '@/components/ItemNotify.vue';
import Login from '@/components/Login.vue';
import utils from "@/utils";

export default {
  name: 'List',
  components: { ListFilter, ListItem, Pagination, ViewItemInfo, ItemNotify, Login },
  data() {
    return {
      pics: null,                   // 分类Banner
      list: [],                     // 商品列表
      filterOpts: {                 // 筛选过滤条件
        genders: { items: [], checked: [], collapse: true },
        colors: { items: [], checked: [], collapse: true },
        sizes: { items: [], checked: [], collapse: true },
        prices: { items: [], checked: "", collapse: true }
      },
      sort: '',
      total: 0,                     // 总记录条数
      limit: 24,                    // 每页条数
      currPage: 1,                  // 当前页码
      isCollapse: true,             // mini筛选过滤组件是否折叠不显示
      showSelectedFilterItem: false,// 是否显示已选中的筛选过滤条件
      // 
      viewItem: null,
      notifyItem: null,
      showLogin: false,
      returnUrl: '',
      categoryRes: {
        breadcrumb: [],
        name: '',
      }
    }
  },
  created() {
    let category = this.$route.params.id;
    if (category) {
      // 
    } else {
      this.$router.replace({ name: 'Home' });
    }
  },
  mounted() {
    this.initWithArgs();
  },
  methods: {
    initWithArgs() {
      // 处理地址栏参数
      let { genders, sizes, colors, prices, sort, limit, page } = this.$route.query;
      genders ? (this.filterOpts.genders.checked = genders.toString().split(",")) : (this.filterOpts.genders.checked = []);
      sizes ? (this.filterOpts.sizes.checked = sizes.toString().split(",")) : (this.filterOpts.sizes.checked = []);
      colors ? (this.filterOpts.colors.checked = colors.toString().split(",")) : (this.filterOpts.colors.checked = []);
      prices ? (this.filterOpts.prices.checked = prices.toString()) : (this.filterOpts.prices.checked = '');
      sort && ['new', 'sales', 'price:desc', 'price:asc'].indexOf(sort) != -1 ? (this.sort = sort) : (this.sort = 'new');
      limit && [24, 48, 96].indexOf(parseInt(limit)) != -1 ? (this.limit = parseInt(limit)) : (this.limit = 24);
      if (page && !isNaN(page)) {
        page = parseInt(page, 10);
        page = page <= 0 ? 1 : page;
        this.currPage = page;
      } else {
        this.currPage = 1
      }
      this.toggleFilterSelected();
      this.loadSource();
    },
    loadSource() {
      let newArgs = {
        id: ~~this.$route.params.id.split('-').pop(),
        where: {
          gender: "",
          size: "",
          color: "",
          price: ""
        },
        sort: this.sort,
        limit: this.limit,
        currPage: this.currPage
      };
      let { genders, sizes, colors, prices } = this.filterOpts;
      if (genders?.checked?.length || sizes?.checked?.length || colors?.checked?.length || prices?.checked?.length) {
        genders?.checked?.length && (newArgs.where.gender = genders.checked.toString());
        sizes?.checked?.length && (newArgs.where.size = sizes.checked.toString());
        colors?.checked?.length && (newArgs.where.color = colors.checked.toString());
        prices?.checked?.length && (newArgs.where.price = prices.checked.toString());
      }
      api[types.GET_LIST_BY_NAV_ID](newArgs).then(res => {
        if (res?.code == 1) {
          let { list, total, category } = res.data;
          this.categoryRes = category;
          utils.setPageTitle(category.name)
          this.list = list;
          this.total = total;
          this.pics = category?.pic;
          this.$nextTick(() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
          });
        }
      }).catch(err => {
        console.error(err);
      });
      api[types.GET_LIST_LAYER](newArgs).then(res => {
        if (res?.code == 1) {
          let _filters = res.data?.filters || []
          let getFilter = code => _filters.find(i => i.code === code)?.options
          this.filterOpts.genders.items = getFilter('gender');
          this.filterOpts.colors.items = getFilter('color');
          this.filterOpts.sizes.items = getFilter('size');
          this.filterOpts.prices.items = getFilter('price');
        } else {
          console.warn(res);
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    // 判断已选中的过滤条件是否需要展示
    toggleFilterSelected() {
      let filterOpts = this.filterOpts;
      if (filterOpts?.genders?.checked?.length || filterOpts?.sizes?.checked?.length || filterOpts?.colors?.checked?.length || filterOpts?.prices?.checked?.length) {
        this.showSelectedFilterItem = true;
      } else {
        this.showSelectedFilterItem = false;
      }
    },
    // 切换mini筛选过滤条件组件的显示状态
    toggleMiniFilter(evt, collapse) {
      this.isCollapse = collapse != undefined ? collapse : !this.isCollapse;
    },
    // 删除已选的过滤条件
    removeFilterItem(opt, ref) {
      let query = Object.assign({}, this.$route.query);
      let optCache = query[opt];
      if (optCache) {
        optCache = optCache.split(",");
        let idx = optCache.findIndex(i => i == ref);
        optCache.splice(idx, 1);
        if (optCache.length) {
          query = Object.assign({}, query, { [opt]: optCache.toString() });
        } else {
          delete query[opt];
        }
        this.$router.push({
          path: this.$route.path,
          query: query
        });
      } else {
        console.warn(`Option: ${opt}, Ref: ${ref}, Query: ${JSON.stringify(query)}`);
      }
    },
    // 清除所有过滤条件
    clearAll() {
      let newQuery = Object.assign({}, this.$route.query);
      delete newQuery.genders;
      delete newQuery.sizes;
      delete newQuery.colors;
      delete newQuery.prices;
      this.$router.push({
        path: this.$route.path,
        query: newQuery
      });
    },
    // 显示商品信息弹窗
    showItemDialog(attr) {
      this.viewItem = attr;
    },
    // 关闭商品信息弹窗
    hideItemDialog() {
      this.viewItem = null;
    },
    // 显示到货通知
    setNotify(info) {
      if (!info || !info.id) return console.warn('缺少商品信息'), false;
      this.viewItem = null;
      this.notifyItem = info;
    },
    // 关闭到货通知
    hideNotifyDialog() {
      this.notifyItem = null;
    },
    // 立即结算
    toCheckout(args) {
      let { size, quantity } = args;
      let ids = `${size.id},${quantity}`;
      if (this.isLogin) {
        let params = { ids }
        api[types.CONFIRM](params).then(async res => {
          if (res?.code == 1) {
            const confirmCacheKey = await this.$store.dispatch('requestCache/setRequestCache', { params, value: res });
            this.$router.push({ path: `/checkout?ids=${ids}&confirmCacheKey=${confirmCacheKey}` });
          } else {
            console.warn(res);
          }
        })
      } else {
        this.hideItemDialog();
        // 修改登录成功跳转地址
        this.returnUrl = `/checkout?ids=${ids}`;
        this.showLoginDialog();
      }
    },
    showLoginDialog() {
      this.showLogin = true;
    },
    hideLoginDialog() {
      this.returnUrl = '';
      this.showLogin = false;
    },
    // 到货通知设置成功
    sendNotify() {
      this.hideNotifyDialog();
    },
    // 更改页码
    changePage({ currPage }) {
      this.currPage = currPage;
      this.loadSource();
    },
    // 更改显示数量、排序
    optsChange(opt) {
      if (['limit', 'sort'].indexOf(opt) != -1) {
        // this.currPage = 1;
        // this.loadSource();
        let newQuery = Object.assign({}, this.$route.query, { [opt]: this[opt] })
        this.$router.push({
          path: this.$route.path,
          query: newQuery
        });
      }
    },
    findItemById(id, items, parents = []) {
      // 遍历当前层级的所有项
      for (const item of items) {
        // 如果当前项的 id 匹配，则返回包含当前项及其所有父级的数组
        if (item.id === id) {
          return [...parents, item];
        }
        // 如果当前项有子项，则递归调用 findItemById 函数
        if (item.children && item.children.length > 0) {
          const foundItem = this.findItemById(id, item.children, [...parents, item]);
          // 如果在子项中找到了匹配的项，则返回包含当前项及其所有父级的数组
          if (foundItem) {
            return foundItem;
          }
        }
      }
      // 如果在当前层级和子项中都没有找到匹配的项，则返回空数组
      return null;
    },
    getCheckedList(option) {
      const { checked, items } = this.filterOpts[option]
      const isItemValid = k => {
        return items?.find(item => {
          if (typeof item == "object") {
            return k == item?.id || k == item?.name
          } else {
            return k == item
          }
        })
      }
      const ret = Array.isArray(checked) ? (checked?.length ? checked.filter(isItemValid) : []) : (isItemValid(checked) ? [checked] : [])
      return ret
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    breadcrumbList() {
      // const filteredData = this.categoryRes.breadcrumb.filter(item => item.show !== 0);
      const filteredData = this.categoryRes.breadcrumb;
      return filteredData;
    },
    navs() {
      let ret = [];
      let ids = this.$route.params.id.split('-');
      let currId = ids?.length ? Number(ids[ids.length - 1]) : null;
      if (currId) {
        let navItem = this.findItemById(currId, this.$store.state.navList)
        ret = navItem?.map((i, index, array) => {
          const path = array.slice(0, index + 1).map(item => item.id).join('-');
          return {
            id: i.id, name: i.name, cover: i.cover, path
          }
        }) || []
      }
      return ret;
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.initWithArgs();
    }
  },
  filters: {
    findFilterItem(ref, filterOptions) {
      if (ref && filterOptions?.items?.length) {
        let ret = filterOptions.items.filter(item => {
          if (typeof item == "object")
            return item.id == ref;
          return item == ref;
        })[0];
        return typeof ret == "object" ? (ret.name || ret.value) : ret;
      }
      return ref;
    }
  }
}
</script>

<style lang="scss" scoped>
.list-container {
  box-sizing: border-box;
  margin: auto;
  width: calc(100% - 20px);
  max-width: 1200px;
  padding: 0 .625rem;

  .list-section {
    max-width: 1200px;
    margin: 0 auto;

    .bread-crumbs {
      width: 100%;
      font-size: calc(.6875rem * 1.6);
      top: 0;
      left: 50%;
      z-index: 1;
      line-height: 1em;
      // line-height: 22px;
      // height: 22px;
      padding: .5em 0;
      text-align: left;

      a {
        font-size: calc(.6875rem * 1.6);
        color: #000;
        margin-right: 5px;

        &:hover {
          font-weight: 400;
          color: #999;
          text-decoration: underline;
        }

        &::after {
          color: #ccc;
          content: "/";
          margin-left: .4em;
          display: inline-block;
        }

        &:last-child::after {
          content: "";
        }
      }
    }

    .list-header {
      box-sizing: border-box;
      width: 100%;
      max-width: 1200px;
      border-bottom: 1px solid #b4b5b4;
      padding: 16px 0 16px;
      position: relative;
      margin: 0 0 calc(1.3125rem * 1.6);
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .list-title {
        font-weight: 400;
        font-size: calc(2rem * 1.6);
        line-height: normal;
        line-height: 1em;
        color: #000;
        cursor: pointer;
        display: block;
        float: left;
        margin: 0;
        margin-right: auto;
        padding: 0;
        max-width: calc(100% - 230px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: auto;
      }

      .list-header-extra {
        display: flex;

        .list-filter-mini {
          display: none;
          height: 40px;
          line-height: 40px;
          padding: 0 0 0 10px;
          text-align: left;
        }

        select {
          width: 100%;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
        }

        .list-limit {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-right: 10px;

          label {
            font-size: calc(.875rem * 1.6);
            letter-spacing: .025em;
            display: block;
            color: #000;
            margin-right: 5px;
            white-space: nowrap;
          }

          & ::v-deep .el-select {
            width: 65px;

            .el-input .el-input__inner {
              border: 2px solid #b4b5b4;
            }
          }
        }

        .list-sort {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          & ::v-deep .el-select {
            width: 110px;

            .el-input .el-input__inner {
              border: 2px solid #b4b5b4;

              &::placeholder {
                color: #333;
              }
            }
          }
        }
      }

      .list-filter-opts {
        display: none;
      }
    }

    .list-filter-opts-selected {
      box-sizing: border-box;
      margin-bottom: 10px;
      width: calc(100% - 20px);
      max-width: 1200px;
      margin: 0 auto calc(1.3125rem * 1.6);
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -ms-flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;

      .list-filter-flag {
        line-height: calc(1.875rem * 1.6);
        font-size: calc(.875rem * 1.6);
        color: #000;
        margin-right: 20px;
        text-transform: capitalize;
      }

      .filter-item {
        color: #000;
        background: #efefef;
        border: 1px solid #b4b5b4;
        margin: 5px 20px 5px 0;
        padding: 0 10px;
        line-height: calc(1.625rem * 1.6);
        font-size: calc(.875rem * 1.6);

        .filter-item-value {
          margin-left: 8px;

          .filter-item-remove {
            margin-left: 5px;
            cursor: pointer;
            color: #000;

            &:hover {
              text-decoration: none;
            }

            .iconfont {
              font-size: 12px;
            }
          }
        }
      }

      .clear-all {
        color: #666;
        font-size: calc(.75rem * 1.6);
        letter-spacing: .025em;
        cursor: pointer;
        text-decoration: underline;

        &:hover {
          font-weight: 400;
          color: #999;
          text-decoration: underline;
        }
      }
    }


    .list-wrapper {
      &::after {
        content: "";
        display: table;
        clear: both;
      }

      .filter-items {
        width: 230px;
        float: left;
      }


      .list-items {
        box-sizing: border-box;
        width: calc(100% - 230px - 50px);
        float: left;
        margin-left: 50px;

        .topic-banner {
          box-sizing: border-box;
          margin: auto;
          width: calc(100% - 20px);
          max-width: 1200px;
          margin-bottom: 10px;
          margin-top: 16px;

          img {
            width: 100%;
          }
        }





        .list-context {
          margin-bottom: 10px;

          .list-result {
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -ms-flex-wrap: wrap;
            -webkit-flex-wrap: wrap;
            flex-wrap: wrap;
            margin: 0;
            padding: 0;

            li {
              border-right: 1px solid #b4b5b4;
              border-bottom: 1px solid #b4b5b4;
              border-top: none;
              margin-top: 0;
              padding: 0;
              width: 33.33333%;
              position: relative;
              box-sizing: border-box;

              &:nth-child(3n+3) {
                border-right: none;
              }
            }
          }

          .paging {
            margin: 40px auto 0;
            position: relative;
            height: 60px;

            .list-footer-size {
              display: flex;
              align-items: center;
              position: absolute;
              top: 50%;
              right: 10px;
              transform: translateY(-50%);

              .list-footer-size-hits {
                font-weight: 400;
                font-size: calc(.875rem * 1.6);
                letter-spacing: .025em;
                color: #000;
                white-space: nowrap;
                margin-right: 4px;
              }

              & ::v-deep .el-select {
                width: 65px;

                .el-input .el-input__inner {
                  border: 2px solid #b4b5b4;
                }
              }
            }
          }
        }
      }
    }
  }

  .dialog {
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: url(../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
      z-index: 1010;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #FFF;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;
      border-radius: 4px;

      .dialog-header {
        position: relative;
        text-align: left;

        .dialog-title {
          border-bottom: 1px solid #b4b5b4;
          font-weight: 400;
          font-size: calc(1.375rem * 1.6);
          color: #000;
          text-transform: uppercase;
          padding: calc(1.25rem * 1.6) calc(1.25rem * 1.6) calc(0.5rem * 1.6) 0;
          margin: 0 calc(1.25rem * 1.6);
          width: calc(100% - 40px);
          box-sizing: border-box;
        }

        .dialog-close {
          width: 32px;
          height: 32px;
          position: absolute;
          top: -15px;
          right: -15px;
          padding: 0;
          border: none;
          border-radius: 0;
          margin: 0;
          background-color: transparent;
          font-size: 0;
          cursor: pointer;

          .close-icon {
            background-image: url(../assets/imgs/icons/onitsukatiger-close.svg);
            background-position: 0 0;
            background-repeat: no-repeat;
            height: 32px;
            width: 32px;
            margin: 0;
            padding: 0;
            display: block;
            text-indent: -99999px;
            overflow: hidden;
          }
        }
      }

      .dialog-body {
        box-sizing: border-box;
        display: flex;
        padding: 20px;
      }
    }

    &.view-item-dialog {
      .dialog-container {
        width: 920px;
        max-width: 95%;

        .dialog-header {
          .dialog-title {
            display: none;
          }
        }
      }
    }

    &.notify-dialog {
      .dialog-container {
        width: 834px;
        background-color: #efefef;

        .dialog-body {
          padding: 20px;
        }
      }
    }

    &.login-dialog {
      .dialog-container {
        width: 470px;
        height: 600px;

        .dialog-header {
          height: 40px;

          .dialog-close {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 32px;
            color: #999999;
            cursor: pointer;
          }
        }

        .dialog-body {
          & ::v-deep .login-component {
            width: 100%;

            .title {
              text-align: center;
            }

            .el-form {
              width: 80%;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .list-container {
    .list-section {
      .bread-crumbs {
        width: 100%;
        font-size: 12px;
        top: 0;
        left: 50%;
        z-index: 1;
        line-height: 1em;
        // line-height: 22px;
        // height: 22px;
        padding: 20px 0 0;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        a {
          font-size: 12px;
          color: #4B4F54;
          margin-right: 5px;

          &:hover {
            font-weight: 400;
            color: #999;
            text-decoration: underline;
          }

          &::after {
            color: #ccc;
            content: "/";
            margin-left: .4em;
            display: inline-block;
          }

          &:last-child::after {
            content: "";
          }
        }
      }

      .list-header {
        border-bottom: 0;
        flex-direction: column;
        justify-content: flex-start;
        padding: 0;


        .list-title {
          font-weight: 400;
          font-size: 20px !important;
          line-height: normal;
          line-height: 1em;
          color: #000;
          cursor: pointer;
          display: block;
          float: left;
          // margin: auto;
          // margin-right: auto;
          padding: 20px 0;
          max-width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }


        .list-header-extra {
          width: 100%;
          .list-filter-mini {
            overflow: hidden;
            display: block;
            padding-right: 31px;
            box-sizing: border-box;
            border: 1px solid #b4b5b4;
            border-radius: 2px;
            background: #efefef url(../assets/imgs/icons/plus.svg) no-repeat scroll;
            background-position: right 10px center;
            position: relative;
            clear: left;
            cursor: pointer;
            float: left;
            width: calc(50% - 5px);

            &.active {
              background: #efefef url(../assets/imgs/icons/minus.svg) no-repeat scroll;
              background-position: right 10px center;
            }
          }

          .list-limit {
            display: none;
          }

          .list-sort {
            width: calc(50% - 5px);
            height: 40px;
            margin: 0;
            margin-left: calc(.625rem * 1.6);
            overflow: hidden;
            display: block;
            // padding-right: 31px;
            box-sizing: border-box;
            border: 1px solid #b4b5b4;
            border-radius: 2px;
            background: #efefef url(../assets/imgs/icons/plus.svg) no-repeat scroll;
            background-position: right 10px center;
            position: relative;

            & ::v-deep .el-select {
              width: 100%;

              .el-input {
                .el-input__inner {
                  border: 0;
                  background: transparent;
                }

                .el-input__suffix {
                  display: none;
                }
              }
            }
          }
        }

        .list-filter-opts {
          display: block !important;
          margin-top: 5px;
          background: #efefef;
          border: 1px solid #b4b5b4;
          float: left;
          display: none;
          padding: calc(.6875rem * 1.6);
          width: calc(100% - 24px);

          .list-filter-opts-close {
            font-weight: 400;
            font-size: 12px;
            padding: 15px 0 5px;
            text-align: center;
            color: #333;
            cursor: pointer;
          }
        }
      }

      .list-wrapper {
        .filter-items {
          display: none;
        }

        .list-items {
          width: 100%;
          margin: 0;


          .list-context {
            .list-result {
              li {
                width: 50%;
                border-bottom: 1px solid #b4b5b4;

                &:nth-child(3n+3) {
                  border-right: 1px solid #b4b5b4;
                }

                &:nth-child(2n+2) {
                  border-right: none;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .list-container {
    .list-section {
      .list-wrapper {
        .list-items {
         

          .list-context {
            .paging {
              .pagination-wrapper {
                .pagination-hits {
                  text-align: left;
                  margin-bottom: 20px;
                }
              }

              .list-footer-size {
                top: 14%;
              }
            }
          }
        }
        .list-header {

            .list-title {
              font-size: 20px;
            }
          }
      }
    }

    .dialog {
      &.view-item-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
        }
      }

      &.notify-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
          background: #FFF;
        }
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .list-container {
    .dialog {
      &.view-item-dialog {
        .dialog-container {
          top: 50px;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-header {
            .dialog-title {
              display: block;
            }

            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.notify-dialog {
        .dialog-container {
          top: 50px;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-header {
            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.login-dialog {
        .dialog-container {
          position: fixed;
          top: 0;
          left: 0;
          transform: none;
          // transform: translate(-50%, 0);
          background: #FFF;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-body ::v-deep .login-component {
            .el-form {
              width: calc(100% - 40px);
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.list-container .dialog.view-item-dialog .dialog-container {
  top: max(50%, 370px);
}

.list-container .dialog.notify-dialog .dialog-container {
  top: max(50%, 355px);
}
</style>
